exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ------------ Base ------------ */\r\nbody {\r\n  background-color: #fff;\r\n  background-image: url('/images/default/background-login.jpg');\r\n  background-attachment: cover;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n/* ------------ Base End ------------ */\r\n#loading img {\r\n  position: fixed;\r\n  z-index: 9999;\r\n  /*height: 2em;*/\r\n  width: 300px;\r\n  overflow: show;\r\n  margin: auto;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n}\r\n\r\n#loading:before {\r\n  z-index: 9999;\r\n  content: '';\r\n  display: block;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/_shared/layout/loading-page/loading-page.component.css
// module id = ../../../../../src/app/_shared/layout/loading-page/loading-page.component.css
// module chunks = main